import { InjectionToken } from '@angular/core';
import * as moment from 'moment';

export const MW_DATE_RANGE_PICKER_LOCALE_CONFIG = new InjectionToken<
  DateRangePickerLocaleConfig
>('date-range-picker.config');
/**
 *  LocaleConfig Interface
 */
export interface DateRangePickerLocaleConfig {
  direction?: string;
  separator?: string;
  weekLabel?: string;
  applyLabel?: string;
  dayLabel?: string;
  daysLabel?: string;
  cancelLabel?: string;
  customRangeLabel?: string;
  daysOfWeek?: string[];
  monthNames?: string[];
  firstDay?: number;
  format?: string;
}
/**
 *  DefaultLocaleConfig
 */
export const DefaultDateRangePickerLocaleConfig: DateRangePickerLocaleConfig = {
  direction: 'ltr',
  separator: ' - ',
  weekLabel: 'CORE.COMPONENT.DATE_RANGE_PICKER.weekAbbr',
  applyLabel: 'CORE.COMPONENT.DATE_RANGE_PICKER.apply',
  cancelLabel: 'CORE.COMPONENT.DATE_RANGE_PICKER.cancel',
  dayLabel: 'CORE.COMPONENT.DATE_RANGE_PICKER.day',
  daysLabel: 'CORE.COMPONENT.DATE_RANGE_PICKER.days',
  customRangeLabel: 'CORE.COMPONENT.DATE_RANGE_PICKER.custom_range',
  daysOfWeek: moment.weekdaysMin(),
  monthNames: moment.months(),
  firstDay: moment.localeData().firstDayOfWeek(),
  format: 'dd.MM.yyyy',
};
